import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";

const PILLS = [
  { img: "/images/net-approved-seller.webp", label: "New Energy Tech Approved Seller" },
  { label: "Clean Energy Council Accredited Installer" },
  { label: "Solar Victoria Approved Retailer" },
  { label: "VEU Accredited Provider" },
  { label: "Authorized Rinnai Dealer" },
  { label: "Brighte accredited vendor" },
];

const Accreditations = () => {
  return (
    <section
      data-testid="accreditations-section"
      className="bg-white border-b border-navy/10 py-12 md:py-16"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5 }}
          className="text-xs font-bold uppercase tracking-[0.25em] text-gdark"
        >
          Accreditations &amp; Compliance
        </motion.p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          {PILLS.map((pill, i) => (
            <motion.span
              key={pill.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: i * 0.06 }}
              data-testid={`accreditation-pill-${i}`}
              className="inline-flex items-center gap-2.5 bg-cream rounded-full px-5 py-2.5 text-sm font-semibold text-navy"
            >
              {pill.img ? (
                <img
                  src={pill.img}
                  alt=""
                  className="h-7 w-7 rounded-full object-cover shrink-0"
                  loading="lazy"
                />
              ) : (
                <ShieldCheck className="h-5 w-5 text-gdark shrink-0" />
              )}
              {pill.label}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Accreditations;
